/**
 * AuthLayout — autenticazione Phase 5 (IMPL-P5-007).
 *
 * Full-height page chrome shared by all auth screens (signup, login,
 * verify-email, etc.). Renders the brand header + an `<Outlet />` slot for
 * route-level children, OR an explicit `children` prop when the consumer
 * wants to compose without React Router (e.g. {@link AuthStatusPage}).
 */
import type { ReactNode } from 'react';
import { Outlet } from 'react-router-dom';
import { FileCheck2 } from 'lucide-react';

interface AuthLayoutProps {
  /**
   * Optional explicit children. When omitted the component renders an
   * `<Outlet />` so it works as a React Router layout route too.
   */
  children?: ReactNode;
}

export function AuthLayout({ children }: AuthLayoutProps) {
  return (
    <main className="min-h-screen bg-background text-foreground flex flex-col items-center justify-center p-6">
      <header className="mb-8 flex flex-col items-center gap-3 text-center">
        <FileCheck2 className="h-12 w-12 text-primary" aria-hidden="true" />
        <p className="text-sm font-medium tracking-tight text-muted-foreground">
          Portale Registrazione Contratti
        </p>
      </header>
      <div className="w-full max-w-md">{children ?? <Outlet />}</div>
    </main>
  );
}
